import React, {ReactNode} from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Sheet from "@mui/joy/Sheet";

type DefaultProps = {
    title: string
    children: string
    open: boolean
    content?: ReactNode
    setOpen: (e: boolean) => void
    onConfirm: () => void | Promise<void>
    /** Нажатие «Нет». Крестик и оверлей только закрывают диалог. */
    onDecline?: () => void | Promise<void>
    /** Дополнительное «Да» (например снять блок). Если нет — кнопка скрыта. */
    extraConfirmLabel?: string
    onExtraConfirm?: () => void | Promise<void>
}

const ConfirmDialog = (props: DefaultProps) => {
    const {title, children,content, open, setOpen, onConfirm, onDecline, extraConfirmLabel, onExtraConfirm} = props;
    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <ModalDialog >
                <ModalClose/>
                <Typography id="filter-modal" level="h2">
                    {title}
                </Typography>
                <Divider sx={{my: 2}}/>
                <Sheet sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                    <Typography id="filter-modal" level="h4">
                        {children}
                    </Typography>
                    {content}
                    <Button
                        onClick={async () => {
                            await onDecline?.();
                            setOpen(false);
                        }}
                        color="neutral"
                    >
                        Нет
                    </Button>
                    <Button
                        onClick={async () => {
                            await onConfirm();
                            setOpen(false);
                        }}
                        color="primary"
                    >
                        Да
                    </Button>
                    {extraConfirmLabel && onExtraConfirm && (
                        <Button
                            onClick={async () => {
                                await onExtraConfirm();
                                setOpen(false);
                            }}
                            color="danger"
                        >
                            {extraConfirmLabel}
                        </Button>
                    )}
                </Sheet>
            </ModalDialog>
        </Modal>
    );
};

export default ConfirmDialog;